import { PurchasableItem } from "@hooks/V2/storyblok"
import {
  isConsolidatedPurchasableItem,
  parseConsolidatedPrice,
} from "@hooks/V2/storyblok/useConsolidatedItem"
import { getSavingsBadge } from "@utils/shop"

export type ProductCardData = {
  productName: string
  imageUrl: string
  imageAlt: string
  priceValue?: string | number
  priceLabelOverride?: YocoCom.PriceLabelOverride
  shortDescription?: string
  ctaText?: string
  ctaLink?: string | YocoCom.YocoLink
  learnMoreButtonUrl?: string | YocoCom.YocoLink
  filterTags?: string[]
  badge?: YocoCom.Badge
  wasPrice?: string | number
  purchasableItem?: PurchasableItem
  reviewSkus?: string[]
}

export const consolidatedItemToProductCard = (
  consolidatedItem: YocoCom.ConsolidatedItem
): ProductCardData => {
  const purchasableItem = isConsolidatedPurchasableItem(consolidatedItem)
    ? consolidatedItem
    : undefined
  const onlineProductItem = isConsolidatedPurchasableItem(consolidatedItem)
    ? undefined
    : consolidatedItem
  const productImage = consolidatedItem.thumbnail

  const productPrice = parseConsolidatedPrice(purchasableItem?.price)
  const originalPrice = parseConsolidatedPrice(purchasableItem?.originalPrice)
  const effectiveBadge =
    (productPrice
      ? getSavingsBadge(productPrice, originalPrice)
      : consolidatedItem.badge) ?? undefined

  const wasPrice =
    productPrice && originalPrice && originalPrice > productPrice
      ? originalPrice
      : undefined

  return {
    productName: consolidatedItem.name,
    imageUrl: productImage?.filename ?? "",
    imageAlt: productImage?.alt || `${consolidatedItem.name}-image`,
    priceValue: productPrice,
    priceLabelOverride: onlineProductItem?.priceLabelOverride,
    shortDescription: consolidatedItem.shortDescription,
    ctaText: consolidatedItem.ctaText,
    ctaLink: consolidatedItem.ctaLink,
    learnMoreButtonUrl: consolidatedItem.detailsLink,
    filterTags: consolidatedItem.filterTags,
    badge: effectiveBadge,
    wasPrice,
    purchasableItem,
    reviewSkus: purchasableItem?.reviewSkus,
  }
}
